import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { TrainingRequirementFacade } from '../+state/training-requirement/training-requirement.facade';
import {
  TrainingRequirementSkeleton,
  TrainingRequirementAudit,
  BusinessPersonTrainingRequirementAudit,
  WarningRuleAudit,
  BusinessPersonWithTrainingSkeleton,
  TrainingGroupAudit,
  TrainingGroupSkeleton,
  TrainingGroupTrainingRequirementAudit
} from '../+models/training-requirement-audit.model';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';

@Component({
  selector: 'sd-portal-training-requirement-profile-audit',
  templateUrl: './training-requirement-profile.component.html',
  styleUrls: ['./training-requirement-profile.component.scss']
})
export class TrainingRequirementProfileComponent implements OnInit {
  trainingRequirementSkeletonsLoading$: Observable<boolean>;
  trainingRequirementSkeletonsLoaded$: Observable<boolean>;
  trainingRequirementSkeletons$: Observable<TrainingRequirementSkeleton[]>;

  trainingRequirementAuditLoading$: Observable<boolean>;
  trainingRequirementAuditLoaded$: Observable<boolean>;
  trainingRequirementAudits$: Observable<TrainingRequirementAudit[]>;

  warningRuleAuditLoading$: Observable<boolean>;
  warningRuleAuditLoaded$: Observable<boolean>;
  warningRuleAudits$: Observable<WarningRuleAudit[]>;

  businessPersonWithTrainingSkeletonsLoading$: Observable<boolean>;
  businessPersonWithTrainingSkeletonsLoaded$: Observable<boolean>;
  businessPersonWithTrainingSkeletons$: Observable<BusinessPersonWithTrainingSkeleton[]>;

  businessPersonTrainingRequirementAuditLoading$: Observable<boolean>;
  businessPersonTrainingRequirementAuditLoaded$: Observable<boolean>;
  businessPersonTrainingRequirementAudits$: Observable<BusinessPersonTrainingRequirementAudit[]>;

  trainingGroupSkeletonsLoading$: Observable<boolean>;
  trainingGroupSkeletonsLoaded$: Observable<boolean>;
  trainingGroupSkeletons$: Observable<TrainingGroupSkeleton[]>;

  trainingGroupAuditLoading$: Observable<boolean>;
  trainingGroupAuditLoaded$: Observable<boolean>;
  trainingGroupAudits$: Observable<TrainingGroupAudit[]>;

  trainingGroupTrainingRequirementAuditLoading$: Observable<boolean>;
  trainingGroupTrainingRequirementAuditLoaded$: Observable<boolean>;
  trainingGroupTrainingRequirementAudits$: Observable<TrainingGroupTrainingRequirementAudit[]>;

  constructor(private readonly trainingRequirementFacade: TrainingRequirementFacade) {}

  ngOnInit() {
    this.trainingRequirementSkeletonsLoading$ =
      this.trainingRequirementFacade.trainingRequirementSkeletonsLoading$;
    this.trainingRequirementSkeletonsLoaded$ =
      this.trainingRequirementFacade.trainingRequirementSkeletonsLoaded$;
    this.trainingRequirementSkeletons$ =
      this.trainingRequirementFacade.trainingRequirementSkeletons$;

    this.trainingRequirementAuditLoading$ =
      this.trainingRequirementFacade.trainingRequirementAuditLoading$;
    this.trainingRequirementAuditLoaded$ =
      this.trainingRequirementFacade.trainingRequirementAuditLoaded$;
    this.trainingRequirementAudits$ = this.trainingRequirementFacade.trainingRequirementAudits$;

    this.warningRuleAuditLoading$ = this.trainingRequirementFacade.warningRuleAuditLoading$;
    this.warningRuleAuditLoaded$ = this.trainingRequirementFacade.warningRuleAuditLoaded$;
    this.warningRuleAudits$ = this.trainingRequirementFacade.warningRuleAudits$;

    this.businessPersonWithTrainingSkeletonsLoading$ =
      this.trainingRequirementFacade.businessPersonWithTrainingSkeletonsLoading$;
    this.businessPersonWithTrainingSkeletonsLoaded$ =
      this.trainingRequirementFacade.businessPersonWithTrainingSkeletonsLoaded$;
    this.businessPersonWithTrainingSkeletons$ =
      this.trainingRequirementFacade.businessPersonWithTrainingSkeletons$;

    this.businessPersonTrainingRequirementAuditLoading$ =
      this.trainingRequirementFacade.businessPersonTrainingRequirementAuditLoading$;
    this.businessPersonTrainingRequirementAuditLoaded$ =
      this.trainingRequirementFacade.businessPersonTrainingRequirementAuditLoaded$;
    this.businessPersonTrainingRequirementAudits$ =
      this.trainingRequirementFacade.businessPersonTrainingRequirementAudits$;

    this.trainingGroupSkeletonsLoading$ =
      this.trainingRequirementFacade.trainingGroupSkeletonsLoading$;
    this.trainingGroupSkeletonsLoaded$ =
      this.trainingRequirementFacade.trainingGroupSkeletonsLoaded$;
    this.trainingGroupSkeletons$ = this.trainingRequirementFacade.trainingGroupSkeletons$;

    this.trainingGroupAuditLoading$ = this.trainingRequirementFacade.trainingGroupAuditLoading$;
    this.trainingGroupAuditLoaded$ = this.trainingRequirementFacade.trainingGroupAuditLoaded$;
    this.trainingGroupAudits$ = this.trainingRequirementFacade.trainingGroupAudits$;

    this.trainingGroupTrainingRequirementAuditLoading$ =
      this.trainingRequirementFacade.trainingGroupTrainingRequirementAuditLoading$;
    this.trainingGroupTrainingRequirementAuditLoaded$ =
      this.trainingRequirementFacade.trainingGroupTrainingRequirementAuditLoaded$;
    this.trainingGroupTrainingRequirementAudits$ =
      this.trainingRequirementFacade.trainingGroupTrainingRequirementAudits$;

    this.trainingRequirementFacade.loadTrainingRequirements();
  }

  onTabChanged(event: MatTabChangeEvent) {
    if (event.index === 0) {
      this.trainingRequirementFacade.loadTrainingRequirements();
    } else if (event.index === 1) {
      this.trainingRequirementFacade.loadBusinessPersonWithTraining();
    } else {
      this.trainingRequirementFacade.loadTrainingGroups();
    }
  }

  loadTrainingRequirementAudits(trainingRequirementId: number) {
    this.trainingRequirementFacade.loadTrainingRequirementAudits(trainingRequirementId);
  }

  nextTrainingRequirementAuditPage(trainingRequirementId: number) {
    this.trainingRequirementFacade.nextTrainingRequirementAuditPage(trainingRequirementId);
  }

  loadWarningRuleAudits(warningRuleId: number) {
    this.trainingRequirementFacade.loadWarningRuleAudits(warningRuleId);
  }

  nextWarningRuleAuditPage(warningRuleId: number) {
    this.trainingRequirementFacade.nextWarningRuleAuditPage(warningRuleId);
  }

  loadBusinessPersonTrainingRequirementAudits(businessPersonTrainingRequirementId: number) {
    this.trainingRequirementFacade.loadBusinessPersonTrainingRequirementAudits(
      businessPersonTrainingRequirementId
    );
  }

  nextBusinessPersonTrainingRequirementAuditPage(businessPersonTrainingRequirementId: number) {
    this.trainingRequirementFacade.nextBusinessPersonTrainingRequirementAuditPage(
      businessPersonTrainingRequirementId
    );
  }

  loadTrainingGroupAudits(trainingGroupId: number) {
    this.trainingRequirementFacade.loadTrainingGroupAudits(trainingGroupId);
  }

  nextTrainingGroupAuditPage(trainingGroupId: number) {
    this.trainingRequirementFacade.nextTrainingGroupAuditPage(trainingGroupId);
  }

  loadTrainingGroupTrainingRequirementAudits(trainingGroupTrainingRequirementId: number) {
    this.trainingRequirementFacade.loadTrainingGroupTrainingRequirementAudits(
      trainingGroupTrainingRequirementId
    );
  }

  nextTrainingGroupTrainingRequirementAuditPage(trainingGroupTrainingRequirementId: number) {
    this.trainingRequirementFacade.nextTrainingGroupTrainingRequirementAuditPage(
      trainingGroupTrainingRequirementId
    );
  }
}
